import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperatorInterceptorService implements HttpInterceptor{
    
    ALLOWED_ENDPOINTS = [];
    ENDPOINT_PARAM = 'operatorId';
    ENDPOINT_VALUE: any = '';
    respu: any;
    constructor() { 
        console.log('Init Interceptor Operator');
        this.ENDPOINT_VALUE = localStorage.getItem('o60pf2u4s9i5db');
    }

    isAllowedEndpoint(url: string):boolean{
        return this.ALLOWED_ENDPOINTS.some(endpoint => url.includes(endpoint))
    }
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isAllowedEndpoint(req.url)) {
            let charachter = '?';
            if(req.urlWithParams.includes('?')){
                charachter = '&';
            }
            if(!req.urlWithParams.includes('operatorId')){
                const endpointUrl = req.urlWithParams + `${charachter}${this.ENDPOINT_PARAM}=${this.ENDPOINT_VALUE}`;
                req = req.clone({ url: endpointUrl });
            }
          }
          return next.handle(req);
    }
}
